// extracted by mini-css-extract-plugin
export default {"listContainer":"listContainer__219987","wishListItem":"wishListItem__4d6f85"};